import { Form, Row } from 'antd'
import styled from 'styled-components'

export const StyledAuthWrapper = styled(Row)`
  position: relative;
  padding: 34px 0;
  min-height: 100vh;

  @media only screen and (max-width: 768px) {
    min-height: calc(100vh - 123px);
  }
`
export const StyledFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px;
  min-height: 470px;
  width: 707px;
  background-color: var(--white);
  box-shadow: 0 13px 32px 9px rgba(0, 0, 0, 0.07);
  border-radius: 15px;
  box-sizing: border-box;
  position: relative;

  h1 {
    color: var(--cognac);
    text-align: center;
    width: 350xp;
  }
  p {
    text-align: center;
    width: 435px;
  }
  .ant-btn {
    justify-content: center;
  }

  .mr-peri {
    position: absolute;
    left: -262px;
  }

  .new-user {
    color: var(--cognac);
    font-size: 25px;
    a {
      text-decoration: underline;
    }
  }

  .subtitle {
    color: var(--red);
    font-size: 14px;
    text-align: center;
    width: auto;
  }
  .resend {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .ant-btn {
      text-decoration: underline;
    }

    .ant-btn:hover,
    .ant-btn[disabled] {
      background-color: inherit !important;
    }
  }

  @media only screen and (max-width: 768px) {
    width: 100% !important;
    box-shadow: none !important;
    border-radius: 0;
    padding: 0 26px;
    .mr-peri {
      display: none;
    }
    .new-user {
      font-size: 20px;
      width: 100%;
    }
    .ant-btn {
      height: 40px;
    }
    .ant-form-item {
      height: 72px;
    }
    .below-fields {
      label, a {
        font-size: 13px;
      }
    }
    p {
      width: auto !important;
    }
    .social-auth {
      .social-media-btn {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin: 10px 5px;
        img {
          width: 27px;
          height: 27px;
          margin-right: 0;
        }
      }
    }
  }
`
export const StyledForm = styled(Form)`
  width: 490px;
  padding: 43px 0;
  background-color: #ffffff;
  .ant-btn {
    justify-content: center;
  }
  .privacy {
    text-align: center;
    width: 450px;
    margin: 35px auto;
  }
  .create-with {
    text-align: center;
    margin: 44px 0 65px 0;
  }
  @media only screen and (max-width: 768px) {
    width: 100% !important;
    border-radius: 0;
    h3 {
      font-size: 22px;
    }
    .create-with {
      margin: 15px 0;
    }
    .privacy {
      width: auto;
      font-size: 16px;
      margin: 40px 0 !important;
    }
  }
`

export const StyledOtpInputWrapper = styled(Row)`
  margin: 55px 0;
  .ant-col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
export const StyledUpdateProfileWrapper = styled.div`
  h1 {
    color: var(--cognac);
    text-align: center;
  }
  img {
    text-align: center;
  }
  .ant-form {
    margin: 0 auto;
  }
`
